import { render, staticRenderFns } from "./VersionDiffModal.vue?vue&type=template&id=aa4b2cfa&"
import script from "./VersionDiffModal.vue?vue&type=script&lang=js&"
export * from "./VersionDiffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports